import axios from 'axios'
import {UserModel} from '../../modules/auth/core/_models'

const API_URL = process.env.REACT_APP_API_URL

export const UPDATE_USER_URL = `${API_URL}/update_user`
export const UPDATE_PASS_URL = `${API_URL}/update_user_password`
export const SIGNALS_URL = `${API_URL}/signals`
export const PURCHASE_SIGNAL_URL = `${API_URL}/purchase_signal`
export const PURCHASED_SIGNALS_URL = `${API_URL}/purchased_signals`
export const ADD_CREDIT_URL = `${API_URL}/add_credit`
export const USE_ANALYSIS_URL = `${API_URL}/use_analysis`

export function updateUser(data: UserModel) {
  return axios.post(UPDATE_USER_URL, data)
}

export function updateUserPassword(data: any) {
  return axios.post(UPDATE_PASS_URL, data)
}

export function fetchSignals() {
  return axios.get(SIGNALS_URL)
}

export function purchaseSignal(signalId: number) {
  return axios.post(PURCHASE_SIGNAL_URL, {signal_id: signalId})
}

export function fetchPurchasedSignals() {
  return axios.get(PURCHASED_SIGNALS_URL)
}

export function addCredit(amount: number) {
  return axios.post(ADD_CREDIT_URL, {amount})
}

export function consumeAnalysis(signalId: number) {
  return axios.post<{status: boolean; analyses_used_count: number; analysis_limit: number; message?: string}>(
    USE_ANALYSIS_URL,
    {signal_id: signalId}
  )
}

export const CRYPTO_CREATE_INVOICE_URL = `${API_URL}/crypto/create-invoice`
export const CRYPTO_PENDING_INVOICE_URL = `${API_URL}/crypto/pending-invoice`
export const CRYPTO_PAYMENT_STATUS_URL = `${API_URL}/crypto/payment-status`
export const CRYPTO_PAYMENTS_URL = `${API_URL}/crypto/payments`
export const NOWPAYMENTS_CREDIT_RATE_URL = `${API_URL}/get_nowpayments_credit_rate`

export function getPendingCryptoInvoice() {
  return axios.get<{
    status: boolean
    pending?: boolean
    order_id?: string
    invoice_url?: string
    credit_amount?: number
    price_usd?: number
    payment_status?: string
    created_at?: string
  }>(CRYPTO_PENDING_INVOICE_URL)
}

export function createCryptoInvoice(creditAmount: number) {
  return axios.post<{
    status: boolean
    invoice_url?: string
    invoice_id?: string
    order_id?: string
    price_usd?: number
    message?: string
  }>(CRYPTO_CREATE_INVOICE_URL, {credit_amount: creditAmount})
}

export function checkCryptoPaymentStatus(orderId: string) {
  return axios.get<{
    status: boolean
    payment_status?: string
    credit_amount?: number
    price_usd?: number
    wallet?: number
    message?: string
  }>(CRYPTO_PAYMENT_STATUS_URL, {params: {order_id: orderId}})
}

export function getNowpaymentsCreditRate() {
  return axios.get<{rate: number}>(NOWPAYMENTS_CREDIT_RATE_URL)
}
